export default __webpack_public_path__ + "static/media/bell_on.c6cd0511.svg";